import { INITIAL_STATE, setCustomer, clearCustomer } from '../core'
import { RECEIVE_CUSTOMER, CLEAR_CUSTOMER } from '../action_creators'

function customer(state=INITIAL_STATE.customer, action) {
    switch(action.type) {
        case RECEIVE_CUSTOMER:
            return setCustomer(action.customer)
        case CLEAR_CUSTOMER:
            return clearCustomer()
        default:
            return state
    }
}

export default customer


// WEBPACK FOOTER //
// ./src/redux/reducers/customer_reducer.js